







































































import Vue from "vue";
import { AiCacheSearchResultItem } from "@/types/ai/aiSearch";
import AiFeedbackNotFound from "./AiFeedbackNotFound.vue";
import Shared from "../../shared";

export default Vue.extend({
    name: "AiSearchResults",
    components: { AiFeedbackNotFound },
    props: {
        items: Array as () => AiCacheSearchResultItem[],
        itemsToShow: Number,
        searchScope: String,
        allItemsLoaded: Boolean,
        showMoreAmount: Number,
        searchText: String,
        portalId: Number
    },
    data: function () {
        return {
            areAllItemsLoaded: false,
            itemsToShowCount: 0
        };
    },
    watch: {
        itemsToShow: {
            handler() {
                this.itemsToShowCount = this.itemsToShow;
            },
            immediate: true
        },
        searchText: {
            handler() {
                this.itemsToShowCount = this.itemsToShow;
            }
        }
    },
    computed: {
        visibleItems(): AiCacheSearchResultItem[] {
            if (this.itemsEmpty) {
                return [];
            }
            return this.items?.slice(0, this.itemsToShowCount);
        },
        showMore(): boolean {
            if (this.itemsEmpty) return false;

            return (this.allItemsLoaded && this.itemsToShowCount >= this.items?.length) == false;
        },
        itemsEmpty(): boolean {
            return this.items?.length == 0;
        },
        itemsPage(): number | null {
            if (this.items?.length <= 0) return null;
            return Math.ceil(this.itemsToShowCount / this.showMoreAmount);
        },
        isLastPage(): boolean {
            return !this.itemsEmpty && this.itemsToShowCount >= this.items?.length;
        },
        shouldShowFeedback(): boolean {
            return this.itemsPage > 1 || this.isLastPage;
        }
    },
    methods: {
        handleClick(item: AiCacheSearchResultItem) {
            this.$emit("item-clicked", item);
        },
        doShowMore() {
            this.itemsToShowCount += this.showMoreAmount;
            this.$emit("show-more", this.itemsToShowCount, this.showMoreAmount);
        },
        shouldLoadAiAnswer(item: AiCacheSearchResultItem): boolean {
            if (item == null || item == undefined) return false;
            //check if aiAnswer is empty, because it can also be cached
            return item.should_generate_answer && !this.aiAnswerAlreadyLoaded(item);
        },
        aiAnswerAlreadyLoaded(item: AiCacheSearchResultItem): boolean {
            return (
                item.answer?.suggested_follow_up_questions !== null &&
                item.answer?.suggested_follow_up_questions !== undefined &&
                item.answer?.suggested_follow_up_questions?.length > 0
            );
        },
        getHighlightedText(text: string): string {
            const regex = /<b>(?:.*?)<\/b>/;
            const match = text.match(regex);
            const nCharacters = 300;
            if (match) {
                const matchStartIndex = match.index;
                const matchEndIndex = matchStartIndex + match[0].length;

                // Calculate the start and end indices for the surrounding text
                const start = Math.max(0, matchStartIndex - nCharacters);
                const end = Math.min(text.length, matchEndIndex + nCharacters);

                // Extract the surrounding text
                const prefix = text.substring(start, matchStartIndex);
                const suffix = text.substring(matchEndIndex, end);
                const surroundingText = prefix + match[0] + suffix;
                return surroundingText;
            } else {
                return text;
            }
        },
        getContentItemUrl(content_item_id: string): string {
            return Shared.iProvaUrl + `/iPortal5/default.aspx?ContentItemID=${content_item_id}`;
        },
        getContentTypeName(item: AiCacheSearchResultItem) {
            if (item.content_type_id == 1 && item.content_sub_type_id == "7") return item.content_sub_type_name;
            if (item.content_type_id == 1) return null;
            if (item.content_type_id == 6) return item.content_sub_type_name;
            return item.content_type_name || null;
        },
        getTypeColor(content_type_id: number) {
            if (content_type_id == 1) return "#673AB7"; //document
            if (content_type_id == 2 || content_type_id == 3) return "#1976D2"; //question list or reporter form
            if (content_type_id == 6) return "#00796B"; //card files
            return "#757575"; //other
        }
    }
});
